import {createReducer} from 'redux-act';
import {SearchResultsDataType} from './searchResultsType';
import {SEARCH_RESULTS} from '../../constants/actions';

export const initialState: SearchResultsDataType = {
    ids: [],
    items: [],
    log_handle: '',
    recommended_message: '',
    total_items_count: 0,
    type: 'items',
    web_session_id: '',
};

export const searchResults = createReducer({}, initialState).on(
    `${SEARCH_RESULTS.GET_SEARCH_RESULTS}_FULFILLED`,
    (state, payload: {data: SearchResultsDataType}): SearchResultsDataType => payload.data,
);
